// Weekbalk onderaan de Dagstart: een rustige schuifbalk van een maand terug tot drie maanden
// vooruit. Slepen toont alleen de doelweek; pas bij loslaten springt het venster (één
// ophaalronde, niet één per tussenliggende week). Zie weekBladeren.js.
import React, { useState } from 'react';
import { Box, Slider, Typography } from '@mui/material';
import { maandagVanWeek, weekVerschil } from './weekBladeren';
import { parseISODate } from '../../utils/weekUtils';

export const WEEK_MIN = -4;
export const WEEK_MAX = 12;

const kort = (iso) => {
  const d = parseISODate(iso);
  return d ? d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '') : iso;
};

const weekLabel = (vandaagISO, n) => (n === 0 ? 'deze week' : `week van ${kort(maandagVanWeek(vandaagISO, n))}`);

/**
 * @param vandaagISO  echte vandaag
 * @param startISO    eerste dag van het zichtbare venster
 * @param onKies      (weekNr relatief aan deze week) => void
 */
function WeekBalk({ vandaagISO, startISO, onKies }) {
  const huidig = Math.max(WEEK_MIN, Math.min(WEEK_MAX, weekVerschil(vandaagISO, startISO)));
  const [sleep, setSleep] = useState(null);
  const waarde = sleep ?? huidig;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, pt: 0.5 }}>
      <Typography sx={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap', minWidth: 118 }}>
        {weekLabel(vandaagISO, waarde)}
      </Typography>
      <Slider
        size="small"
        aria-label="Naar week"
        min={WEEK_MIN}
        max={WEEK_MAX}
        step={1}
        marks={[{ value: 0 }]}
        value={waarde}
        valueLabelDisplay="off"
        getAriaValueText={(n) => weekLabel(vandaagISO, n)}
        onChange={(e, v) => setSleep(v)}
        onChangeCommitted={(e, v) => { setSleep(null); if (v !== huidig) onKies(v); }}
        sx={{
          flex: 1, color: '#94a3b8', height: 3, py: 1,
          '& .MuiSlider-thumb': { width: 12, height: 12, bgcolor: '#475569' },
          '& .MuiSlider-mark': { width: 2, height: 8, bgcolor: '#94a3b8' },
        }}
      />
    </Box>
  );
}

export default React.memo(WeekBalk);
